import IntlMessageFormat from 'intl-messageformat';
import PropTypes from 'prop-types';

/*
    labelMaker -
        Given a template, and variables, it will generate the combined string.
        It supports both passing in a list of values, or a map.
        Because there are currently Lingua values that are in these formats,
        this function must support them.

    Parameters:
        Translation - The lingua value, or string.
        'My Linga Value {0}'
        'My branch {1} Linga Value {0}'
        'Hello: {NAME}, welcome to {BRAND}'

    Example Uses:
    labelMaker('My Linga Value {0}', '5') =>  'My Lingua Value 5'
    labelMaker('My branch {1} Linga Value {0}', 'foo', 'bar') => 'My branch bar Linga Value foo'
    labelMaker('Hello: {NAME}, welcome to {BRAND}', {NAME: 'Phil', BRAND: 'HomeAway'}) => 'Hello: Phil, welcome to HomeAway'
*/

const arrayToObject = (args) => {
    if (args.length === 1 && typeof args[0] === 'object') {
        return args[0];
    }

    const valueMap = {};

    for (let i = 0; i < args.length; i++) {
        valueMap[i] = args[i];
    }
    return valueMap;
};

const labelMaker = (translation = '', ...args) => {
    let formattedMessage = '';
    let valueMap = args;

    if (Array.isArray(args) && args.length) {
        valueMap = arrayToObject(args);
    } else {
        return translation;
    }

    try {
        let intlMessageFormat = new IntlMessageFormat(translation);
        formattedMessage = intlMessageFormat.format(valueMap);
    } catch (e) {
        return translation;
    }
    return formattedMessage;
};

labelMaker.propTypes = {
    translation: PropTypes.string,
    args: PropTypes.array,
};

export default labelMaker;
